import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
@Injectable({
  providedIn: 'root'
})
export class CleverTapUtilityService {

  constructor(private EncrdecrService:EncrdecrService) { }

  androidBridge = environment.androidCleverTapVariable
  IOSBridge = environment.IOSCleverTapVariable

  userLoginEvent(props : Record<string,any>){
    try{
      if((window as any)[this.androidBridge]){
        (window as any)[this.androidBridge].onUserLogin(JSON.stringify(props))
      }
      else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
        const message = {
          action : 'onUserLogin',
          properties : props
        };
        (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
      }
      else if ((window as any).clevertap) {
        console.log("Pushing to CleverTap Web SDK");
        (window as any).clevertap.onUserLogin.push(props)
        //(window as any).clevertap.event.push('onUserLogin', props);
      }
      else{
        console.log(`CleverTap Bridge ${this.androidBridge} not available`);
      }
    }
    catch(err){
        console.log(err);
    }
  }
//Comment by Tishya for IIFL-2030
  // recordEvent(eventName: string, props : Record<string,any>){
  //   console.log(`recordEvent Called with props ${JSON.stringify(props)}  ${eventName}`);
  //   try{
  //     if((window as any)[this.androidBridge]){
  //       (window as any)[this.androidBridge].pushEvent(eventName,JSON.stringify(props))
  //     }
  //     else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
  //       const message = {
  //         action : 'recordEventWithProps',
  //         event : eventName,
  //         properties : props
  //       };
  //       (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
  //     }
  //     else if ((window as any).clevertap) {
  //       console.log("Pushing to CleverTap Web SDK");
  //       (window as any).clevertap.event.push(eventName, props);
  //     }
  //     else{
  //       console.log(`CleverTap Bridge not available`);
  //     }
  //   }
  //   catch(err){
  //     console.log(err);
  //   }
  // }
  recordEvent(eventName: string, props : Record<string,any>){
    console.log(`recordEvent Called with props ${JSON.stringify(props)}  ${eventName}`);
    let rr1 = '',rr2 = '',rr3 = '',rr4 = '',rr5 = ''
    let r1 = "";
    
    let r2 = sessionStorage.getItem('L2D3506kIHSk3E0'); // Session_UserType
    let r3 = sessionStorage.getItem('V8hpPfITcxhEI9x'); // Session_UserEmail
    let r4 = sessionStorage.getItem('Xe003SRRyYEoOC2'); // Session_UserMobile
    
    
    if(r2){
      rr2 = this.EncrdecrService.getDecr(r2)
      if(rr2 == "3"){
        r1 = sessionStorage.getItem('4MPLG9aocUy5o5wwX9r3aA'); //Session UCCCode
       }else{
        r1 = sessionStorage.getItem('m5JkoXISmYRAIuY'); // Session_UserID
       }
       if(r1){
        rr1 = this.EncrdecrService.getDecr(r1)
       }
    }
   
    if(r3){
      rr3 = this.EncrdecrService.getDecr(r3)
    }
    if(r4){
      if(rr2 == "3"){
        let Tax_statusId = this.EncrdecrService.getDecr(sessionStorage.getItem("TF4q3aPcsYpaEDoa4ROM")).toString();
        rr4 = this.EncrdecrService.getDecr(r4);
        if(Tax_statusId =="21" || Tax_statusId == "24")
        {
          rr4 = "";
        }else{
          rr4 = rr4.includes('+91') ? rr4.replace(/\s+/g, '') : `+91${rr4.trim()}`
        }
      } else{
        rr4 = this.EncrdecrService.getDecr(r4);
        rr4 = rr4.includes('+91') ? rr4.replace(/\s+/g, '') : `+91${rr4.trim()}`
      }
      
    }

    let UserInfo = {
        "Identity": rr1,
        "UserType": rr2,
        "Email": rr3,
        "Phone": rr4,
    }
    let Final = {...UserInfo,...props}
    // alert(JSON.stringify(Final))
    try{
      if((window as any)[this.androidBridge]){
        (window as any)[this.androidBridge].pushEvent(eventName,JSON.stringify(Final))
      }
      else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
        const message = {
          action : 'recordEventWithProps',
          event : eventName,
          properties : Final
        };
        (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
      }
      else if ((window as any).clevertap) {
        console.log("Pushing to CleverTap Web SDK");
        //(window as any).clevertap.onUserLogin.push(eventName,Final)
        (window as any).clevertap.event.push(eventName, Final);
      }
      else{
        console.log(`CleverTap Bridge not available`);
      }
    }
    catch(err){
      console.log(err);
    }
  }

  pushChargedEvent(chargeDetails: Record<string,any>, items: any[]){
    console.log(`pushChargedEvent Called with ${JSON.stringify(chargeDetails)} ${JSON.stringify(items)}`);
    try{
      if((window as any)[this.androidBridge]){
        (window as any)[this.androidBridge].pushChargedEvent(JSON.stringify(chargeDetails),JSON.stringify(items))
      }
      else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
        const message = {
          action : 'recordChargedEvent',
          chargteDetails : chargeDetails,
          items : items
        };
        (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
      }
      else{
        console.log(`CleverTap Bridge ${this.androidBridge} not available`);
      }
    }
    catch(err){
      console.log(err);
    }
  }

  pushUserProfile(props : Record<string,any>){
    console.log(`pushChargedEvent Called with ${JSON.stringify(props)}`);
    try{
      if((window as any)[this.androidBridge]){
        (window as any)[this.androidBridge].pushProfile(JSON.stringify(props))
      }
      else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
        const message = {
          action : 'profilePush',
          properties : props
        };
        (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
      }
      else{
        console.log(`CleverTap Bridge ${this.androidBridge} not available`);
      }
    }
    catch(err){
      console.log(err);
    }
  }

  profileAddMultiValueForKey(key: string, values: any[]){
    console.log(`profileAddMultiValueForKey Called with ${JSON.stringify(values)}`);
    try{
      if(values?.length > 0){
        if((window as any)[this.androidBridge]){
          (window as any)[this.androidBridge].addMultiValuesForKey(key,JSON.stringify(values))
        }
        else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
          const message = {
            action : 'profileAddMultiValues',
            values : values,
            key : key
          };
          (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
        }
        else{
          console.log(`CleverTap Bridge ${this.androidBridge} not available`);
        }
      }
    }
    catch(err){
      console.log(err);
    }
  }

  profileAddValueForKey(key: string, values: string){
    console.log(`profileAddValueForKey Called with ${values+" "+key}`);
    try{
        if((window as any)[this.androidBridge]){
          (window as any)[this.androidBridge].addMultiValueForKey(key,values)
        }
        else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
          const message = {
            action : 'profileAddMultiValue',
            values : values,
            key : key
          };
          (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
        }
        else{
          console.log(`CleverTap Bridge ${this.androidBridge} not available`);
        }
    }
    catch(err){
      console.log(err);
    }
  }

  profileRemoveMultiValueForKey(key: string, values: any[]){
    console.log(`profileRemoveMultiValueForKey Called with ${key+" "+JSON.stringify(values)}`);
    try{
      if(values?.length > 0){
        if((window as any)[this.androidBridge]){
          (window as any)[this.androidBridge].removeMultiValuesForKey(key,JSON.stringify(values))
        }
        else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
          const message = {
            action : 'profileRemoveMultiValues',
            values : values,
            key : key
          };
          (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
        }
        else{
          console.log(`CleverTap Bridge ${this.androidBridge} not available`);
        }
      }
    }
    catch(err){
      console.log(err);
    }
  }

  profileRemoveValueForKey(key: string, values: string){
    console.log(`profileRemoveValueForKey Called with ${values+" "+key}`);
    try{
        if((window as any)[this.androidBridge]){
          (window as any)[this.androidBridge].removeMultiValueForKey(key,values)
        }
        else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
          const message = {
            action : 'profileRemoveMultiValue',
            values : values,
            key : key
          };
          (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
        }
        else{
          console.log(`CleverTap Bridge ${this.androidBridge} not available`);
        }
    }
    catch(err){
      console.log(err);
    }
  }

  profileRemoveAllValueForKey(key: string){
    console.log(`profileRemoveAllValueForKey Called with ${key}`);
    try{
        if((window as any)[this.androidBridge]){
          (window as any)[this.androidBridge].removeValueForKey(key)
        }
        else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
          const message = {
            action : 'profileRemoveValueForKey',
            key : key
          };
          (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
        }
        else{
          console.log(`CleverTap Bridge ${this.androidBridge} not available`);
        }
    }
    catch(err){
      console.log(err);
    }
  }

  profileSetValueForKey(key: string, values: any[]){
    console.log(`profileSetValueForKey Called with ${key+" "+JSON.stringify(values)}`);
    try{
      if(values?.length > 0){
        if((window as any)[this.androidBridge]){
          (window as any)[this.androidBridge].setMultiValueForKey(key,JSON.stringify(values))
        }
        else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
          const message = {
            action : 'profileSetMultiValues',
            values : values,
            key : key
          };
          (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
        }
        else{
          console.log(`CleverTap Bridge ${this.androidBridge} not available`);
        }
      }
    }
    catch(err){
      console.log(err);
    }
  }

  IncrementValueForKey(key: string, values: number){
    console.log(`IncrementValueForKey Called with ${key+" "+values}`);
    try{
        if((window as any)[this.androidBridge]){
          (window as any)[this.androidBridge].incrementValue(key,values)
        }
        else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
          const message = {
            action : 'profileIncrementValueBy',
            values : values,
            key : key
          };
          (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
        }
        else{
          console.log(`CleverTap Bridge ${this.androidBridge} not available`);
        }
    }
    catch(err){
      console.log(err);
    }
  }

  DecrementValueForKey(key: string, values: number){
    console.log(`DecrementValueForKey Called with ${key+" "+values}`);
    try{
        if((window as any)[this.androidBridge]){
          (window as any)[this.androidBridge].decrementValue(key,values)
        }
        else if((window as any).webkit?.messageHandlers?.[this.IOSBridge]){
          const message = {
            action : 'profileDecrementValueBy',
            values : values,
            key : key
          };
          (window as any).webkit.messageHandlers[this.IOSBridge].postMessage(message);
        }
        else{
          console.log(`CleverTap Bridge ${this.androidBridge} not available`);
        }
    }
    catch(err){
      console.log(err);
    }
  }
}
